import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { AuthService } from 'src/app/services/auth.service';
import * as FileSaver from 'file-saver';
import { IntroPage } from '../intro/intro.page';
import { TimelineService } from 'src/app/services/timeline.service';
// declare var FileSaver;

declare var Phaser;

class GameScene extends Phaser.Scene {


  
  mapWidth = 2912;
  mapHeight = 2912;
  poly: any;

  whereX = 0;
  whereY = 0;
  animTarget = null;
  animTextTarget = null;

  pin;

  constructor(config) {
      super(config);
  }

  preload() {

     // console.log('preload');
    this.load.image('map', 'assets/images/map.jpg');
    this.load.image('ship', 'assets/images/kompasik.png');
    this.load.image('pointer', 'assets/images/pointer.png');
    this.load.image('pin', 'assets/images/pin.png');

    this.load.image('authority', 'assets/kompas/value_images/authority.svg');
    this.load.image('equality', 'assets/kompas/value_images/equality.svg');
    this.load.image('liberty', 'assets/kompas/value_images/liberty.svg');
    this.load.image('might', 'assets/kompas/value_images/might.svg');
    this.load.image('peace', 'assets/kompas/value_images/peace.svg');
    this.load.image('progress', 'assets/kompas/value_images/progress.svg');
    this.load.image('tradition', 'assets/kompas/value_images/tradition.svg');
    this.load.image('wealth', 'assets/kompas/value_images/wealth.svg');
  }

  updateDirect()
    {
        if (this.cursors.left.isDown)
        {
            this.ship.setAngle(-90);
            this.ship.x -= 2.5;
        }
        else if (this.cursors.right.isDown)
        {
            this.ship.setAngle(90);
            this.ship.x += 2.5;
        }

        if (this.cursors.up.isDown)
        {
            this.ship.setAngle(0);
            this.ship.y -= 2.5;
        }
        else if (this.cursors.down.isDown)
        {
            this.ship.setAngle(-180);
            this.ship.y += 2.5;
        }
    }

  create() {

     // console.log('create');

    this.cameras.main.setBounds(0, 0, this.mapWidth + 500, this.mapHeight + 500);
    this.game.events.on('destroy', () => {

       // console.log('destroy destroy');
    });

    this.add.image(0, 0, 'map').setOrigin(0);

    const graphics = this.add.graphics();
    graphics.lineStyle(2, 0x000000);

    
    
    // const rt = this.add.renderTexture(0, 0, 300, 300);

    const circle0 = this.add.circle(this.mapWidth / 2, this.mapHeight / 2, 1190, 0x000000);
    circle0.setAlpha(0.12);
    // rt.draw(circle0, 300, 300);

    const circle = this.add.circle(this.mapWidth / 2, this.mapHeight / 2, 900, 0x000000);
    circle.setAlpha(0.1);
    // rt.draw(circle, 300, 300);

    const circle2 = this.add.circle(this.mapWidth / 2, this.mapHeight / 2, 600, 0x000000);
    circle2.setAlpha(0.1);
    // rt.draw(circle2, 300, 300);

    const circle3 = this.add.circle(this.mapWidth / 2, this.mapHeight / 2, 300, 0xFFFFFF);
    circle3.setAlpha(0.15);
    // rt.draw(circle3, 300, 300);
/*
    this.tweens.add({
        targets: rt,
        alphaTopLeft: { value: 0, duration: 333, ease: 'Power1' },
        alphaBottomRight: { value: 0, duration: 333, ease: 'Power1' },
        alphaBottomLeft: { value: 0, duration: 333, ease: 'Power1', delay: 333 },
        yoyo: true,
        loop: -1
    });
*/

     // console.log('kompasData', ProfilePage.kompasData);
    // prawa obywatelskie
    const g = ProfilePage.kompasData.g;
    // swiatopoglad
    const s = ProfilePage.kompasData.s;
    // economy
    const e = ProfilePage.kompasData.e;
    // diplomacy
    const d = ProfilePage.kompasData.d;

    const graphicsT = this.add.graphics({ fillStyle: { color: 0x00FFFF } });

    const dlugoscLinii = this.mapWidth;

    const punktNaLiniiPrawaObyw = dlugoscLinii / 100 * g;
    const punktNaLiniiEkonomia = dlugoscLinii / 100 * e;
    const punktNaLiniiDyplo = dlugoscLinii / 100 * d;
    const punktNaLiniiSwiatopo = dlugoscLinii / 100 * s;

     // console.log('prawa', punktNaLiniiPrawaObyw, '/', dlugoscLinii, punktNaLiniiPrawaObyw);
     // console.log('economy', punktNaLiniiEkonomia, '/', dlugoscLinii, punktNaLiniiEkonomia / dlugoscLinii);
     // console.log('diplomacy', punktNaLiniiDyplo, '/', dlugoscLinii, punktNaLiniiDyplo / dlugoscLinii);
     // console.log('swiatopoglad', punktNaLiniiSwiatopo, '/', dlugoscLinii, punktNaLiniiSwiatopo / dlugoscLinii);

    // freedom
    const xx1 = this.mapWidth / 2;
    const yy1 = this.mapHeight - punktNaLiniiPrawaObyw;

    // swiatopoglad
    const xx4 = punktNaLiniiSwiatopo;
    const yy4 = this.mapHeight / 2;

    // economy
    const xx2 = punktNaLiniiEkonomia / dlugoscLinii * dlugoscLinii;
    const yy2 = this.mapHeight - punktNaLiniiEkonomia / dlugoscLinii * dlugoscLinii;
    let mnoznik;
    let dodatek;

    if (punktNaLiniiEkonomia / dlugoscLinii > .5)
    {
      mnoznik = (punktNaLiniiEkonomia / dlugoscLinii - 0.5);
      dodatek = mnoznik * punktNaLiniiEkonomia * 0.7;
      // xx2 = this.mapWidth / 2 - dodatek;
      // yy2 = this.mapWidth / 2 + dodatek;
       // console.log('ekonomia  MARKET', punktNaLiniiEkonomia / dlugoscLinii, punktNaLiniiEkonomia, mnoznik);
    }
    else
    {
      //  // console.log('ekonomia  SOCIAL');
      mnoznik = (punktNaLiniiEkonomia / dlugoscLinii);
      dodatek =  mnoznik * this.mapWidth;
      // xx2 = this.mapWidth / 2 + dodatek;
      // yy2 = this.mapWidth / 2 - dodatek;
       // console.log('ekonomia  SOCJAL', punktNaLiniiEkonomia / dlugoscLinii, mnoznik, dodatek);
    }

    // diplomacy
    const xx3 = punktNaLiniiDyplo / dlugoscLinii * dlugoscLinii;
    const yy3 = punktNaLiniiDyplo / dlugoscLinii * dlugoscLinii;


    const points = {
      x1: xx1,
      y1: yy1,
      x2: xx2,
      y2: yy2,
      x3: xx3,
      y3: yy3,
      x4: xx4,
      y4: yy4
    };

    const triangleDGE = new Phaser.Geom.Triangle(points.x1, points.y1, points.x2, points.y2, points.x3, points.y3);
    graphicsT.fillTriangleShape(triangleDGE);
    // const areaDGE = Phaser.Geom.Triangle.Area(triangleDGE);
    

    const triangleGES = new Phaser.Geom.Triangle(points.x2, points.y2, points.x3, points.y3, points.x4, points.y4);
    graphicsT.fillTriangleShape(triangleGES);


    

    const myIsland = {
      x: (points.x1 + points.x2 + points.x3 + points.x4) / 4,
      y: (points.y1 + points.y2 + points.y3 + points.y4) / 4
    };

    //  // console.log('my XY', myIsland, triangleGES.getTopRight);

    //  areaGES = Phaser.Geom.Triangle.Area(triangleGES);

    // const triangleDES = new Phaser.Geom.Triangle(this.mapWidth / 2, this.mapHeight / 2, 0, 500, 500, 500);
    // graphicsT.fillTriangleShape(triangleDES);
    // const areaDES = Phaser.Geom.Triangle.Area(triangleDES);

    // this.input.on('pointermove',  (pointer) => {

        // triangle.x3 = pointer.x;
        // triangle.y3 = pointer.y;

        // redraw();

    // });

    // LINIA N/S
    graphics.beginPath();
    graphics.moveTo(this.mapWidth / 2, 0);
    graphics.lineTo(this.mapWidth / 2, this.mapHeight);
    graphics.closePath();
    graphics.strokePath();

    // LINIA W/E
    graphics.beginPath();
    graphics.moveTo(0, this.mapHeight / 2);
    graphics.lineTo(this.mapWidth, this.mapHeight / 2);
    graphics.closePath();
    graphics.strokePath();

    // LINIA ne/sw
    graphics.beginPath();
    graphics.moveTo(this.mapWidth, 0);
    graphics.lineTo(0, this.mapHeight);
    graphics.closePath();
    graphics.strokePath();

    // LINIA nw/se
    graphics.beginPath();
    graphics.moveTo(0, 0);
    graphics.lineTo(this.mapWidth, this.mapHeight);
    graphics.closePath();
    graphics.strokePath();


    

    // linia wolnosc/kontrola
    /*
    graphics.lineStyle(20, 0xFF0000);

    graphics.beginPath();
    graphics.moveTo(this.mapWidth / 2, this.mapHeight / 2);
    graphics.lineTo(this.mapWidth / 2, this.mapHeight / 2 + (this.mapHeight / 100) * (g - 50));
    graphics.closePath();
    graphics.strokePath();

    // linia rynek/rownosc
    graphics.lineStyle(20, 0x00FF00);

    graphics.beginPath();
    graphics.moveTo(this.mapWidth / 2, this.mapHeight / 2);
    graphics.lineTo(this.mapWidth / 2, this.mapHeight / 2 + (this.mapHeight / 100) * (e - 50));
    graphics.closePath();
    graphics.strokePath();

    
    this.poly = new Phaser.Polygon();
    this.poly.setTo([ new Phaser.Point(200, 100), new Phaser.Point(350, 100), new Phaser.Point(375, 200), new Phaser.Point(150, 200) ]);
    graphics.beginFill(0xFF33ff);
    graphics.drawPolygon(this.poly.points);
    graphics.endFill();
*/

    const txtLiberty = g.toFixed(2) + '%';
    const txtEco = (100 - e).toFixed(2) + '%';
    const txtPro = s.toFixed(2) + '%';
    const txtWorld = d.toFixed(2) + '%';
    const txtAuth = (100 - g).toFixed(2) + '%';
    const txtEquali = e.toFixed(2) + '%';
    const txtTraditio = (100 - s).toFixed(2) + '%';
    const txtNarod = (100 - d).toFixed(2) + '%';

    const liberty = this.add.image(this.mapWidth / 2, 333 - 70, 'liberty').setOrigin(0.5, 0.5).setInteractive({ cursor: 'pointer' });
    const libertyText = this.add.text(this.mapWidth / 2, 333 - 70 - 175,
      txtLiberty, {fontSize: 60, wordWrap: {width: 500} }).setOrigin(0.5, 0.5);
    libertyText.setStroke('#000000', 15);
    libertyText.setShadow(5, 5, '#000000', 3);
    // libertyText.setAlpha(0);
    this.whereX = this.mapWidth / 2;
    this.whereY = this.mapHeight / 2;
    this.animTarget = liberty;
    this.animTextTarget = libertyText;
    liberty.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = this.mapWidth / 2 + 300;
      this.whereY = 333 - 70;
      this.animTarget = liberty;
      this.animTextTarget = libertyText;
    });

    const authority = this.add.image(this.mapWidth / 2, this.mapHeight - 333 + 50, 'authority').setOrigin(0.5, 0.5).setInteractive({ cursor: 'pointer' });
    const authorityText = this.add.text(this.mapWidth / 2, this.mapHeight - 333 + 195,
      txtAuth, {fontSize: 60, wordWrap: {width: 500} }).setOrigin(0.5, 0.5);
    authorityText.setStroke('#000000', 15);
    authorityText.setShadow(5, 5, '#000000', 3);
    // authorityText.setAlpha(0);

    authority.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
        //  // console.log('pointer', localX, localY);
        this.whereX = this.mapWidth / 2 + 300;
        this.whereY = this.mapHeight - 333 + 50;
        this.animTarget = authority;
        this.animTextTarget = authorityText;
    });

    const equality = this.add.image(2241 + 50, 697 - 25 - 50, 'equality').setOrigin(0.5, 0.5).setInteractive({ cursor: 'pointer' });
    const equalityText = this.add.text(2241 + 50, 697 - 25 - 50 - 175, txtEquali, {fontSize: 60, wordWrap: {width: 600} });
    equalityText.setStroke('#000000', 15);
    equalityText.setShadow(5, 5, '#000000', 3).setOrigin(0.5, 0.5);
    // equalityText.setAlpha(0);
    equality.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = 2241 + 50;
      this.whereY = 697 - 25 - 50;
      this.animTarget = equality;
      this.animTextTarget = equalityText;
    });

    const wealth = this.add.image(this.mapWidth - 2241 - 50,
      this.mapHeight - 697 + 25 + 50, 'wealth').setOrigin(0.5, 0.5).setInteractive({ cursor: 'pointer' });
    const wealthText = this.add.text(this.mapWidth - 2241 - 50,
      this.mapHeight - 697 + 25 + 50 + 175,
      txtEco, {fontSize: 60, wordWrap: {width: 600} }).setOrigin(0.5, 0.5);
    wealthText.setStroke('#000000', 15);
    wealthText.setShadow(5, 5, '#000000', 3);
    // wealthText.setAlpha(0);
    wealth.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = this.mapWidth - 2241 - 50;
      this.whereY = this.mapHeight - 697 + 25 + 50;
      this.animTarget = wealth;
      this.animTextTarget = wealthText;
    });
    

    
    
    const might = this.add.image(this.mapWidth - 2241 - 50, 697 - 25 - 50, 'might').setOrigin(0.5, 0.5).setInteractive({ cursor: 'pointer' });
    const mightText = this.add.text(this.mapWidth - 2241 - 50, 697 - 25 - 50 - 175, txtNarod, {fontSize: 60, wordWrap: {width: 500} });
    mightText.setStroke('#000000', 15);
    mightText.setShadow(5, 5, '#000000', 3).setOrigin(0.5, 0.5);
    // mightText.setAlpha(0);
    might.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = this.mapWidth - 2241 - 50;
      this.whereY = 697 - 25 - 50;
      this.animTarget = might;
      this.animTextTarget = mightText;
    });
    
    
    const peace = this.add.image(2241 + 50, this.mapHeight - 697 + 25 + 50, 'peace').setOrigin(0.5, 0.5).setInteractive({ cursor: 'pointer' });
    const peaceText = this.add.text(2241 + 50, this.mapHeight - 697 + 25 + 50 + 175,
      txtWorld, {fontSize: 60, wordWrap: {width: 700} }).setOrigin(0.5, 0.5);
    
    peaceText.setStroke('#000000', 15);
    peaceText.setShadow(5, 5, '#000000', 3);
    // peaceText.setAlpha(0);
    peace.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = 2241 + 50;
      this.whereY = this.mapHeight - 697 + 25 + 50;
      this.animTarget = peace;
      this.animTextTarget = peaceText;
    });
    
    
    const progress = this.add.image(2605 + 20 + 25, this.mapHeight / 2, 'progress').setOrigin(0.5, 0.5).setInteractive({ cursor: 'pointer' });
    const progressText = this.add.text(2605 + 20 + 25, this.mapHeight / 2 - 175,
      txtPro, {fontSize: 60, wordWrap: {width: 700} }).setOrigin(0.5, 0.5);

    progressText.setStroke('#000000', 15);
    progressText.setShadow(5, 5, '#000000', 3);
    // progressText.setAlpha(0);
    progress.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = 2605 + 20 + 25;
      this.whereY = this.mapHeight / 2;
      this.animTarget = progress;
      this.animTextTarget = progressText;
    });
    
    const tradition = this.add.image(this.mapWidth - 2605 - 20 - 25,
       this.mapHeight / 2, 'tradition').setOrigin(0.5, 0.5).setInteractive({ cursor: 'pointer' });
    const traditionText = this.add.text(this.mapWidth - 2605 - 20 - 25, this.mapHeight / 2 - 175,
      txtTraditio, {fontSize: 60, wordWrap: {width: 700} }).setOrigin(0.5, 0.5);
    traditionText.setShadow(5, 5, '#000000', 3);
    traditionText.setStroke('#000000', 15);
    // traditionText.setAlpha(0);
    tradition.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = this.mapWidth - 2605 - 20 - 25;
      this.whereY = this.mapHeight / 2;
      this.animTarget = tradition;
      this.animTextTarget = traditionText;
    });
    
    
    
    // this.text = this.add.text(100, 100).setText('Ahoj marynarzu!').setScrollFactor(2);
    // this.text.setShadow(1, 1, '#FFFFFF', 2);

    this.cameras.main.setZoom(.3);
    this.cameras.main.centerOn(this.mapWidth / 2, this.mapHeight / 2);

    this.cursors = this.input.keyboard.createCursorKeys();
    this.kotwica = this.physics.add.image(this.mapWidth / 2 - 6, this.mapHeight / 2, 'ship');
    this.kotwica.setAlpha(0.3);
    this.kotwica.setScale(2.3);
    this.kotwica.setInteractive().on('pointerdown', (pointer, localX, localY, event) => {
      //  // console.log('pointer', localX, localY);
      this.whereX = this.mapWidth / 2 + 100;
      this.whereY = this.mapWidth / 2;
      this.animTarget = this.kotwica;
    });

    this.ship = this.physics.add.image(myIsland.x, myIsland.y, 'pointer').setOrigin(0.5, 0.5);

    this.pin = this.physics.add.image(myIsland.x, myIsland.y, 'pin').setOrigin(0.05, 0.95);
    this.pin.setScale(.5);
    this.pin.disableInteractive();
    

    // ship = this.add.image(400.5, 301.3, 'ship');

    // this.cameras.main.startFollow(this.ship, true, 0.09, 0.09);
    // this.cameras.main.roundPixels = true;

    // this.cameras.main.setZoom(4);

    // this.textCenter = this.add.text(100, 100).setText('!!!!').setScrollFactor(0);
    // this.textCenter.setShadow(1, 1, '#000000', 2);

    // this.text = this.add.text(304, 230).setText('Click to move').setScrollFactor(0);
    // this.text.setShadow(1, 1, '#000000', 2);

    this.tweens.add({
      targets: graphicsT,
      alpha: .4,
      duration: 100
    });

    this.tweens.add({
      targets: graphicsT,
      delay: 500,
      alpha: .25,
      ease: 'Back.easeInOut',
      yoyo: true,
      duration: 5000,
      repeat: -1,
    });

    this.tweens.add({
      targets: this.kotwica,
      scale: 1.95,
      alpha: .4,
      rotation: 2 * Math.PI,
      ease: 'Back.easeInOut',
      yoyo: true,
      delay: 500,
      duration: 70000,
      repeat: -1,
    });

    this.tweens.add({
      targets: circle0,
      alpha: 0.2,
      scale: 0.9,
      ease: 'Sine.easeInOut',
      yoyo: true,
      repeat: -1,
      duration: 6000
    });

    this.tweens.add({
      targets: graphics,
      alpha: 0.4,
      ease: 'Back.easeInOut',
      yoyo: true,
      delay: 2500,
      duration: 5000,
      repeat: -1,
    });

    this.tweens.add({
      targets: circle,
      alpha: 0,
      ease: 'Sine.easeInOut',
      yoyo: true,
      scale: 1.15,
      repeat: -1,
      duration: 4500
    });

    this.tweens.add({
      targets: circle2,
      alpha: 0,
      ease: 'Sine.easeInOut',
      yoyo: true,
      scale: 1.15,
      repeat: -1,
      duration: 3000
    });

    this.tweens.add({
      targets: circle3,
      alpha: 0,
      scale: 1.15,
      ease: 'Sine.easeInOut',
      yoyo: true,
      repeat: -1,
      duration: 1500
    });

    this.tweens.add({
      targets: this.kotwica,
      scale: 1.75,
      alpha: .4,
      rotation: 2 * Math.PI,
      ease: 'Back.easeInOut',
      yoyo: true,
      delay: 500,
      duration: 70000,
      repeat: -1,
    });


    let pos = 0;


    let isBlocked = false;


    this.input.on('pointerup', function() {

        if (isBlocked)
        {
          // return;
        }

        isBlocked = true;

        const cam = this.cameras.main;


        
        cam.pan(this.whereX, this.whereY, 3000, 'Cubic.easeOut');
        // cam.zoomTo(.9, 3000);
        // pos++;
        this.tweens.add({
          targets: this.animTarget,
          scale: 1.1,
          ease: 'Back.easeInOut',
          yoyo: true,
          duration: 1300
        });
        this.tweens.add({
          targets: this.animTextTarget,
          scale: 1.2,
          yoyo: true,
          ease: 'Back.easeInOut',
          delay: 500,
          duration: 1000
        });

        // setTimeout(() => { isBlocked = false; }, 3000);
        // pos = 9;
    }, this);

  }


  update() {
    const cam = this.cameras.main;
    let zoomPercent: any = localStorage.getItem('zoom');
    //  // console.log('czy mam zoom?', zoomPercent);

    if (!zoomPercent)
    {
      zoomPercent = 30;
    }

    const jakiToNum: number = zoomPercent as number;
    cam.zoomTo(1 * jakiToNum * 1 / 100, 200);

    cam.pan(this.whereX, this.whereY, 200);

    return;

    this.ship.setVelocity(0);

    if (this.cursors.left.isDown)
    {
        this.ship.setAngle(-90).setVelocityX(-200);
    }
    else if (this.cursors.right.isDown)
    {
        this.ship.setAngle(90).setVelocityX(200);
    }

    if (this.cursors.up.isDown)
    {
        this.ship.setAngle(0).setVelocityY(-200);
    }
    else if (this.cursors.down.isDown)
    {
        this.ship.setAngle(-180).setVelocityY(200);
    }
    // this.text.setText(['Click to move', 'x: ' + cam.scrollX, 'y: ' + cam.scrollY ]);
  }
}








@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  public static kompasData: any;

  phaserGame: Phaser.Game;
  config: Phaser.Types.Core.GameConfig;

  cleanSupportURL: any;

  account;
  isLoggedIn;
  showingAccountID;
  // itemDoc: any;
  isItMe;
  shownProfile;

  szer = '100%';
  wysoko = '1550px';
  subpage = 'mapa';

  ifrejm;
  zoomPercent = 25;


  modal;

  txtAkwenu = 'Akwen';
  txtKoordy = 'Koordynaty';

  prevAccount = '';

  // private itemDoc: AngularFirestoreDocument<any>;
  // item: Observable<any>;
  wasHere = false;
  shownProfileData;

  constructor(public sanitizer: DomSanitizer, public toastController: ToastController, private modalController: ModalController,
              private auth: AuthService, private afs: AngularFirestore, private app: AppComponent, private timelineService: TimelineService,
              private router: Router, private route: ActivatedRoute, public afa: AngularFireAuth) {
                this.config = {
                    type: Phaser.AUTO,
                    width: '100%',
                    height: '100%',
                    physics: {
                        default: 'arcade'
                    },
                    parent: 'game',
                    scene: GameScene
                };
               }

  ngOnInit() {

    
    this.ifrejm = document.getElementById('ifrejm');

    this.showingAccountID = this.route.snapshot.params.userId;

    
    if (this.auth.account)
    {
       // console.log('showingAccountID', this.auth.account.uid, this.showingAccountID);
    }

    this.afa.authState.subscribe(user => {

      if (user)
      {
        this.account = user;
         // console.log('profile user', this.account.uid);
        // this.auth.czekAccount();
        this.isLoggedIn = true;

        this.txtAkwenu = 'Akwen';
        this.txtKoordy = 'Koordynaty';

        if (this.account.uid === this.showingAccountID)
        {
           // console.log('isItMe TAK');
          this.isItMe = true;
          this.txtAkwenu = 'Twój akwen';
          this.txtKoordy = 'Twoje koordynaty';
        }
      }
      else {

         // console.log('BRAK KOLO');
        this.isLoggedIn = false;
      }
    });
  }
  async presentToastWithOptions(isMe) {

     // console.log('1111', this.router.url);

    

    let msg;
    if (isMe)
    {
      msg = 'Wyniki Twojego Kompasa Piratów będą dostępne po ukończeniu pomiarów. Musisz odpowiedzieć na wszystkie 70 pytań.';
    }
    else
    {
      msg = 'Poszukiawny wynik Kompasa Piratów, nie istnieje :/';
    }

    

    const toast = await this.toastController.create({
      header: 'NIE ZNALEZIONO AKWENU',
      message: msg,
      position: 'middle',
      buttons: [
        {
          text: 'Włącz Kompas!',
          role: 'cancel',
          handler: () => {
             // console.log('Cancel clicked');
            this.router.navigate(['/p3']);
          }
        }, {
          text: 'OK',
          role: 'cancel',
          handler: () => {
            
          }
        }
      ]
    });
    toast.present();
  }

  zoomChanged(evt)
  {
     // console.log('zoom', this.zoomPercent);
    localStorage.setItem('zoom', this.zoomPercent.toString());
  }

  async copyToClip() {
    const input = document.createElement('input');
    input.setAttribute('value', 'https://kompas.polskapartiapiratow.pl' + this.router.url);
    document.body.appendChild(input);
    input.select();
    const result = document.execCommand('copy');
    document.body.removeChild(input);
     // console.log('copied?', result);

    let toast;
    if (result)
    {
      toast = await this.toastController.create({
        header: 'Link do profilu został skopiowany',
        message: 'Mozesz go teraz wkleić gdziekolwiek za pomocą "Ctrl-V" lub funkcji "wklej".',
        position: 'middle',
        color: 'dark',
        buttons: [
          {
            text: 'ok',
            role: 'cancel'
          }
        ]
      });
    }
    else
    {
      toast = await this.toastController.create({
        header: 'Kopiowanie linku nie powiodło się',
        message: 'Musisz ręcznie skopiować URL za pomocą "Ctrl-C" lub funkcji "kopiuj".',
        position: 'middle',
        buttons: [
          {
            text: 'ok',
            role: 'cancel'
          }
        ]
      });

    }
    toast.present();
 }

 async onMyPro()
 {
   // console.log('onMyPro');
  if (!this.isItMe)
  {
    return;
  }
  
  await this.presentModal();
  const { data } = await this.modal.onWillDismiss();
   // console.log('?', data);
  if (data !== undefined)
  {
    this.auth.myImageAvatar = this.timelineService.myOwnImage;
    this.auth.saveMyImage(this.account.uid, this.auth.myImageAvatar).then( backer => {
       // console.log('backer', backer);
    });
  }
  else
  {
     // console.log('chyba to samo, albo brak');
  }
 }


  goBackToMap()
  {
     // console.log('goBackToMap');
    this.router.navigate(['/maps']);
    const domain = window.location.protocol + '//' + window.location.host + '/maps/';
    //  // console.log('domain', domain);
    window.location.replace(domain);
  }
  
  ionViewWillEnter()
  {
    if (this.wasHere)
    {
       // console.log('!!!!!! was here');
      window.location.reload();
      return;
    }

    if (this.shownProfileData)
    {
      this.shownProfileData = null;
    }

    if (this.phaserGame)
    {
       // console.log('!!!!!! juz jest phaserGame', this.phaserGame);
      window.location.reload();
      return;
    }

    

    this.shownProfileData = this.auth.getKompasData(this.showingAccountID).subscribe((data: any) => {
      //  // console.log('item account', data);
      if (data === undefined)
      {
         // console.log('nie ma jeszcze akanta w URL', this.router.url);
        
        if (this.router.url === '/p3')
        {
           // console.log('juz w p3');
          return;
        }
        else
        {
          this.presentToastWithOptions(this.isItMe);
        }
      }
      else
      {
        this.auth.presentRenderWarningOptions();
         // console.log('Poka akant', data);
        ProfilePage.kompasData = {};
        ProfilePage.kompasData.g = parseFloat(data.g);
        ProfilePage.kompasData.d = parseFloat(data.d);
        ProfilePage.kompasData.e = parseFloat(data.e);
        ProfilePage.kompasData.s = parseFloat(data.s);
        ProfilePage.kompasData.avatarURL = data.avatar;
        this.timelineService.myOwnImage = data.avatar;
         // console.log('ProfilePage.kompasData', ProfilePage.kompasData);
        this.auth.myImageAvatar = ProfilePage.kompasData.avatarURL;

         // console.log('Poka gotowy IMG', data.avatar);
        if (this.isItMe && data.avatar === undefined)
        {
           // console.log('robimy swój nowy IMG');
          // this.createImageOfAkwen();
        }
        // const gameDiv: HTMLDivElement = document.createElement('div') as HTMLDivElement;
        // gameDiv.id = 'game';
        // document.body.appendChild(gameDiv);

         // console.log('wasHere before?', this.wasHere);
        if (this.wasHere)
        {
          return;
        }
        else
        {
          this.phaserGame = new Phaser.Game(this.config);
          this.wasHere = true;
        }
      }
    });
  }

  async createImageOfAkwen()
  {

    await this.app.awaitFunction(3000);

    const gameDiv: HTMLCanvasElement = document.getElementById('game').children[0] as HTMLCanvasElement;
    const dataURL = gameDiv.toDataURL();
    const dataIMG: any = dataURL.split(',')[1];
    const blob = this.b64toBlob(dataIMG, 'image/png');
    // gameDiv.toBlob( (blobb) => {
    //  // console.log('blobb', blobb);
    //  FileSaver.saveAs(blobb, 'image.png');
    // });

    FileSaver.saveAs(blob, 'image.png');
  }

  b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    const sliceSize = 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
   
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
   
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
   
      const byteArray = new Uint8Array(byteNumbers);
   
      byteArrays.push(byteArray);
    }
   
    const blob = new Blob(byteArrays, { type: contentType });
     // console.log(blob);
    return blob;
  }

  

  async presentModal() {
    this.modal = await this.modalController.create({
      component: IntroPage,
      cssClass: 'my-custom-class'
    });
    return await this.modal.present();
  }

  changeTab(tab)
  {
    //  // console.log('changeTab', tab.detail.value);
    const gameDiv = document.getElementById('game') as HTMLDivElement;
    if (tab.detail.value === 'mapa')
    {
       // console.log('mapa');
      // this.phaserGame = new Phaser.Game(this.config);
      // gameDiv.setAttribute('visibility', 'hidden');
    }
    else if (tab.detail.value === 'akwen')
    {
      
      gameDiv.setAttribute('visibility', 'visible');
       // console.log('ProfilePage.kompasData', ProfilePage.kompasData);
      const link = 'assets/kompas/results.html?e=' 
        + ProfilePage.kompasData.e + '&d=' + ProfilePage.kompasData.d + '&g=' + ProfilePage.kompasData.g + '&s=' + ProfilePage.kompasData.s;
      
      
      this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(link);
       // console.log('akwen', this.cleanSupportURL);
    }
    else if (tab.detail.value === 'postac')
    {
       // console.log('postac');
    }
  }

  goBackToStart()
  {
     // console.log('------------------- goBackToStart');

    this.phaserGame.destroy(true, true);
    this.phaserGame = null;

    this.router.navigateByUrl('/p3');
  }

}



